import { render } from "./FileOverlay.vue?vue&type=template&id=f55dfa0a&scoped=true"
import script from "./FileOverlay.vue?vue&type=script&lang=js"
export * from "./FileOverlay.vue?vue&type=script&lang=js"

import "./FileOverlay.vue?vue&type=style&index=0&id=f55dfa0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f55dfa0a"]])

export default __exports__